/**
 * EXALLAXE · Manifesto · Galeria Corredor (v1.2)
 * Posiciona os 10 quadros em zigue-zague (offset 200px entre lados).
 * Atualiza CSS custom properties --trilho-esq-x e --trilho-dir-x no wrapper,
 * consumidas pelos pseudo-elementos ::before/::after que renderizam os trilhos.
 * Se este JS falhar, o fallback CSS (12% / 88%) mantém os trilhos visíveis em posição aproximada.
 */
(function() {
  'use strict';

  const wrapper = document.getElementById('manifesto-galeria-wrapper');
  const galeria = document.getElementById('manifesto-galeria');
  const corpo = document.getElementById('manifesto-galeria-corpo');

  if (!wrapper || !galeria || !corpo) return;

  const quadros = Array.from(document.querySelectorAll('.manifesto-galeria__quadro'));

  const Q_WIDTH = 180;
  const Q_HEIGHT = 180;
  const OFFSET = 200; // zigue-zague vertical entre lados

  function calcularPosicoes() {
    if (window.innerWidth <= 900) {
      // Mobile: reset estilos inline
      quadros.forEach(q => {
        q.style.top = '';
        q.style.left = '';
      });
      galeria.style.minHeight = '';
      return;
    }

    const wrapperRect = wrapper.getBoundingClientRect();
    const corpoRect = corpo.getBoundingClientRect();
    const galRect = galeria.getBoundingClientRect();
    const corpoHeight = corpoRect.height;

    // Centro horizontal das colunas laterais relativos ao wrapper (para trilhos)
    const corpoLeftWrap = corpoRect.left - wrapperRect.left;
    const corpoRightWrap = corpoRect.right - wrapperRect.left;
    const wrapperWidth = wrapperRect.width;

    const xEsqWrap = corpoLeftWrap / 2;
    const xDirWrap = corpoRightWrap + (wrapperWidth - corpoRightWrap) / 2;

    // Setar custom properties → pseudo-elementos ::before / ::after posicionam-se aqui
    wrapper.style.setProperty('--trilho-esq-x', xEsqWrap + 'px');
    wrapper.style.setProperty('--trilho-dir-x', xDirWrap + 'px');

    // Centro horizontal das colunas laterais relativos à .manifesto-galeria (para quadros)
    if (quadros.length > 0) {
      const xEsqGal = xEsqWrap - (galRect.left - wrapperRect.left);
      const xDirGal = xDirWrap - (galRect.left - wrapperRect.left);

      const usableH = corpoHeight - Q_HEIGHT - OFFSET;
      const step = usableH / 4;

      const esqPositions = [0, 1, 2, 3, 4].map(i => step * i);
      const dirPositions = [0, 1, 2, 3, 4].map(i => step * i + OFFSET);

      let esqIdx = 0;
      let dirIdx = 0;
      quadros.forEach(q => {
        const lado = q.dataset.lado;
        let top, left;
        if (lado === 'esq') {
          top = esqPositions[esqIdx++];
          left = xEsqGal - Q_WIDTH / 2;
        } else {
          top = dirPositions[dirIdx++];
          left = xDirGal - Q_WIDTH / 2;
        }
        q.style.top = top + 'px';
        q.style.left = left + 'px';
      });

      const maxBottom = Math.max(
        ...quadros.map(q => parseFloat(q.style.top) + Q_HEIGHT)
      );
      galeria.style.minHeight = Math.max(corpoHeight, maxBottom) + 'px';
    }
  }

  function init() {
    calcularPosicoes();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(calcularPosicoes);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(calcularPosicoes, 120);
  });

  document.addEventListener('shopify:section:load', calcularPosicoes);
  document.addEventListener('shopify:section:reorder', calcularPosicoes);
})();
